<template>
  <el-container class="wxworkFileMessages" >
    
    <el-header class="header-style">
    <el-divider content-position="left">企业微信群文件发送记录</el-divider>
    <el-row class="mb-10" :gutter="10">
      <el-col :span="24">
        <el-select clearable v-model="searchArr.chat_id" filterable remote reserve-keyword placeholder="输入群名搜素" size="mini" :remote-method="searchNameremoteMethod" :loading="searchLoading" @change="handleSearchChange">
          <el-option v-for="group in searchChatList"
          :key="group.id"
          :label="group.name"
          :value="group.chat_id">
          </el-option>
        </el-select>
        <el-date-picker
          v-model="searchArr.msgtime"
          size="mini"
          type="daterange"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
          @change="handleSearchChange">
        </el-date-picker>
      </el-col>
    </el-row>
  </el-header>
  <el-main class="main-style">
    <el-table height="calc(100vh - 276px)" :data="pageData" size="mini" border style="width: 100%">
      <el-table-column label='群名'>
        <template slot-scope="scope">
          <el-tooltip :content="scope.row.group_chat ? scope.row.group_chat.name : ''" :open-delay="500" placement="top">
            <span class="hide-style">{{ scope.row.group_chat ? scope.row.group_chat.name : '' }}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label='发送人' prop='content'>
        <template slot-scope="scope">
          <el-tooltip :content="getSendName(scope.row)" :open-delay="500" placement="top">
            <span class="hide-style">{{ getSendName(scope.row) }}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label='文件'>
        <template slot-scope="scope">
          <el-tooltip :content="scope.row.msgtype === 'file' ? scope.row.filename : 'image.png'" :open-delay="500" placement="top">
            <span class="hide-style">{{ scope.row.msgtype === 'file' ? scope.row.filename : 'image.png' }}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label='发送时间'>
        <template slot-scope="scope">
          <el-tooltip :content="scope.row.msgtime" :open-delay="500" placement="top">
            <span class="hide-style">{{ scope.row.msgtime }}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="聊天记录" width="80">
        <template slot-scope="scope">
          <el-tooltip class="item"  effect="dark" content="企业微信聊天记录" placement="top">
            <el-button type="primary" size="mini" icon="el-icon-s-comment" @click="handleWxWorkChatOpen(scope.row)" circle></el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
  </el-main>
  <el-footer class="footer-style">
    <el-pagination
      background
      class="mt-10 text-r"
      layout="total, sizes, prev, pager, next, jumper"
      :hide-on-single-page="false"
      :current-page="pageOption.currentPage"
      :page-size="pageOption.pageSize"
      :page-sizes="[10, 20, 30, 50, 100, 500]"
      :total="pageOption.total"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange">
    </el-pagination>
  </el-footer>

    <el-drawer title="企业微信聊天记录" direction="rtl" :visible.sync="wxWorkChatDrawer" :before-close="handWxWorkChatClose" size="50%">
      <div class="m-tabs-content">
        <el-row>
          <wx-work-chat :chatId="wxWorkChatId" :chatName="wxWorkChatName" :betweenDate="WxworkBetweenDate"></wx-work-chat>
        </el-row>
      </div>
    </el-drawer>
  </el-container>
</template>

<script>
import WxWorkChat from 'common/WxWorkChat'
export default {
  name: 'WxworkFileMessages',
  components: {
    WxWorkChat
  },
  data () {
    return {

      pageData: [],
      pageOption: {
        total: 0,
        currentPage: 1, // 当前页数
        pageSize: 30 // 每页显示条数
      },
      searchArr: {
        chat_id: '',
        msgtime: ''
      },
      searchLoading: false,
      searchChatList: [],
      wxWorkChatDrawer: false,
      wxWorkChatId: null,
      wxWorkChatName: null,
      WxworkBetweenDate: ''
    }
  },
  computed: {
    searchStr: function () {
      let str = ''
      for (let key in this.searchArr) {
        str += '&' + key + '=' + this.searchArr[key]
      }

      return str
    },    
    collapse () {
      return this.$store.state.collapse
    }
  },
  methods: {
    getPageData () {
      this.$axios.get('/api/admin/wx_work_group_chat/files?page=' + this.pageOption.currentPage + '&pageSize=' + this.pageOption.pageSize + this.searchStr)
        .then((res) => {
          let { data } = res
          if (data.code === 0) {
            this.pageData = data.data.pageData.data
            this.pageOption.total = data.data.pageData.total
          }
        })
    },
    handleSizeChange (val) {
      this.pageOption.pageSize = val
      this.pageOption.currentPage = 1
      this.getPageData()
    },
    handleCurrentChange (val) {
      this.pageOption.currentPage = val
      this.getPageData()
    },
    getSendName (row) {
      let name = '未知客户姓名，请添加为企业微信好友'
      if (row.employee) {
        name = row.employee.name
      }

      if (row.external) {
        name = row.external.name
      }

      return name
    },
    searchNameremoteMethod (query) {
      if (query !== '') {
        this.searchLoading = true
        setTimeout(() => {
          this.searchLoading = false
          this.searchChats(query)
        }, 200)
      } else {
        this.searchChatList = []
      }
    },
    searchChats (query) {
      this.$axios.get('/api/admin/wx_work_group/searchGroup/' + query)
        .then((res) => {
          let { data } = res
          if (data.code === 0) {
            this.searchChatList = data.data
          }
        })
    },
    handleSearchChange (val) {
      this.pageOption.currentPage = 1
      this.getPageData()
    },
    handleWxWorkChatOpen (row) {
      this.wxWorkChatDrawer = true
      setTimeout(() => {
        this.wxWorkChatId = row.roomid
        this.wxWorkChatName = row.group_chat ? row.group_chat.name : null
        this.WxworkBetweenDate = row.msgtime
      })
    },
    handWxWorkChatClose (done) {
      this.wxWorkChatId = null
      this.wxWorkChatName = null
      this.WxworkBetweenDate = ''
      done()
    }
  },
  mounted () {
    this.getPageData()
  }
}
</script>

<style lang="stylus" scoped>
  @import '~styles/varibles.styl'
  @import '~styles/vertical.styl'
  .wxworkFileMessages
    marginLeft()
    max-height: 100vh;
    .header-style
      height: 100px !important;
      padding: 0px !important;
    .main-style
      padding: 0px !important;
      // overflow-y: auto;
    .footer-style
      text-align: right;
      .el-pagination
        padding-top: 15px;
    .mt-10
      margin-top: .2rem
    .mb-10
      margin-bottom: .2rem
    .text-r
      text-align: right
    .hide-style
      display: inherit
      overflow: hidden
      text-overflow: ellipsis
      white-space: nowrap
    .m-tabs-content
      padding: 0px 0.2rem 0px 0.4rem
</style>



// WEBPACK FOOTER //
// src/pages/conversation/WxworkFileMessages.vue